export default {
  web: {
    footer: {
      product: "Prodotto",
      company: "Azienda",
      download: "Download",
      pricing: "Prezzi",
      bonuses: "Bonus",
      copyright: "Tutti i diritti riservati.",
    },
  },
};
